import LoginError from './LoginError';
class InvalidLatitude extends LoginError {
    constructor(options) {
        super('Latitude provided by user is not valid', options);
    }
}
export default InvalidLatitude;
